module.exports = __webpack_public_path__ + "static/media/refund-posting.59de448c.svg";